import CustomDrawer from "../shared/CustomDrawer";
import { useEffect, useState, useRef } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { ReactComponent as CloseIcon } from "../../assets/icons/clear_black.svg";
import FilterCheckbox from "./filterTab/FilterCheckbox";
import FilterRadio from "./filterTab/FilterRadio";
import depositList from "./filterTab/staticContent/deposit.list";
import withdrawList from "./filterTab/staticContent/withdraw.list";
import statusList from "./filterTab/staticContent/status.list";
import dateList from "./filterTab/staticContent/date.list";

export default function FilterWrapperBottomSheet({
  filters,
  setFilters,
  reset,
  closeFilterBar,
  filterBarVisibility,
  defaultTypeValue,
}) {
  const [selectedFilter, setSelectedFilter] = useState(
    JSON.parse(JSON.stringify(filters))
  );
  const [tabValue, setTabValue] = useState("depositGroup");
  const [filterList, setFilterValue] = useState(depositList);

  useEffect(() => {
    setTabValue(defaultTypeValue);
  }, [defaultTypeValue, filterBarVisibility]);

  useEffect(() => {
    switch (tabValue) {
      case "depositGroup":
        setFilterValue(depositList);
        break;
      case "withdrawGroup":
        setFilterValue(withdrawList);
        break;
      case "statusGroup":
        setFilterValue(statusList);
        break;
      case "date":
        setFilterValue(dateList);
        break;
      case "none":
        setFilterValue(depositList);
        break;
      default:
        setFilterValue({});
    }
  }, [tabValue]);

  const changeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const onSubmit = () => {
    closeFilterBar();
    setFilters({ ...selectedFilter });
  };

  const onSetNewFilter = (group, value) => {
    var filter = {
      ...selectedFilter,
    };
    if (Array.isArray(filter[group])) filter[group].push(value);
    else filter[group] = value;

    setSelectedFilter({ ...filter });
  };

  const onRemoveFilter = (group, value) => {
    var filter = {
      ...selectedFilter,
    };
    if (Array.isArray(filter[group])) {
      var index = filter[group].indexOf(value);
      if (index !== -1) {
        filter[group].splice(index, 1);
      }
    } else {
      delete filter[group];
    }
    setSelectedFilter({ ...filter });
  };

  const closeAndResetFilterBar = () => {
    setSelectedFilter(JSON.parse(JSON.stringify(filters)));
    closeFilterBar();
  };

  return (
    <>
      <CustomDrawer
        open={filterBarVisibility}
        onClose={() => {
          closeAndResetFilterBar();
          return false;
        }}
      >
        <Box
          component="div"
          display="flex"
          color="primary.main"
          sx={{
            mb: 2,
            color: "common.white",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <CloseIcon
            width={18}
            height={18}
            onClick={() => closeAndResetFilterBar()}
          />

          <Typography
            variant="subtitle2"
            color="grey.2"
            onClick={() => reset()}
          >
            حذف فیلتر
          </Typography>
        </Box>
        <Tabs
          TabIndicatorProps={{ style: { background: "secondary.main" } }}
          value={tabValue}
          onChange={changeTab}
          variant="fullWidth"
          aria-label="scrollable prevent tabs example"
          sx={{
            borderBottom: (theme) => `1px solid ${theme.palette.grey[10]}`,
            ".MuiTabs-indicator": {
              background: (theme) => theme.palette.secondary.main,
            },
            ".Mui-selected": {
              color: (theme) => theme.palette.secondary.main + "!important",
            },
            ".MuiTouchRipple-root ": {
              opacity: 0,
            },
          }}
        >
          <Tab label="واریز" value={"depositGroup"} />
          <Tab label="برداشت" value={"withdrawGroup"} />
          <Tab label="وضعیت" value={"statusGroup"} />
          <Tab label="زمان" value={"date"} />
        </Tabs>

        {(tabValue == "statusGroup" || tabValue == "date") && (
          <FilterRadio
            onSetNewFilter={onSetNewFilter}
            onRemoveFilter={onRemoveFilter}
            filters={selectedFilter}
            groupType={tabValue}
            filterList={filterList}
          />
        )}

        {(tabValue == "withdrawGroup" || tabValue == "depositGroup") && (
          <FilterCheckbox
            onSetNewFilter={onSetNewFilter}
            onRemoveFilter={onRemoveFilter}
            filters={selectedFilter}
            groupType={tabValue}
            filterList={filterList}
          />
        )}

        <LoadingButton
          onClick={onSubmit}
          sx={{
            mt: 2,
            color: "common.white",
            typography: "h3",
          }}
          variant="contained"
          fullWidth
        >
          نمایش نتایج
        </LoadingButton>
      </CustomDrawer>
    </>
  );
}
